import { render, staticRenderFns } from "./HomeContainer.vue?vue&type=template&id=70483596&"
import script from "./HomeContainer.vue?vue&type=script&lang=js&"
export * from "./HomeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports